/**
 * Data layer for `real-time-event-alerts-conversion-chargeback-fraud-cap-hit`. Thin typed fetch wrappers over /api/v1/real-time-event-alerts-conversion-chargeback-fraud-cap-hit.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface RealTimeEventAlertsConversionChargebackFraudCapHitRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListRealTimeEventAlertsConversionChargebackFraudCapHitResponse {
	count: number;
	items: RealTimeEventAlertsConversionChargebackFraudCapHitRow[];
}

export interface CreateRealTimeEventAlertsConversionChargebackFraudCapHitBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/real-time-event-alerts-conversion-chargeback-fraud-cap-hit";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListRealTimeEventAlertsConversionChargebackFraudCapHitResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListRealTimeEventAlertsConversionChargebackFraudCapHitResponse>(res);
}

export async function create(body: CreateRealTimeEventAlertsConversionChargebackFraudCapHitBody): Promise<RealTimeEventAlertsConversionChargebackFraudCapHitRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<RealTimeEventAlertsConversionChargebackFraudCapHitRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys = {
	all: ["real-time-event-alerts-conversion-chargeback-fraud-cap-hit"] as const,
	list: () => [...realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys.all] as const,
	detail: (id: string) => [...realTimeEventAlertsConversionChargebackFraudCapHitQueryKeys.all, id] as const,
};
